import { filter, flow, get, map } from 'lodash/fp';

const mapStats = flow(
  filter('display'),
  map(item => ({
    id: item.id,
    name: item.name,
    quantity: item.value,
    score: item.score,
    unitValue: item.score_per_value
  }))
);

function decodePlayerGameStats(data) {
  return {
    played: !!get('player.played', data),
    score: get('player.score', data),
    statistics: mapStats(get('player.stats', data))
  };
}

export default decodePlayerGameStats;
